import React from 'react';
// 1. Import styles from both CSS Modules
import homeStyles from './Home.module.css'; // For the animated background
import techStyles from './Technology.module.css'; // For component-specific styles
import logo from "../Assets/technology.png";

export const Technology = () => {
    return (
        // 2. Use the mainContainer from Home.module.css to apply the background
        <div className={homeStyles.mainContainer}>
            {/* 3. Use the contentWrapper to layer content on top */}
            <div className={homeStyles.contentWrapper}>

                {/* Page Title */}
                <h1 className={techStyles.heading}>
                    Technology
                </h1>

                {/* Content Block */}
                <div className={techStyles.techContainer}>
                    {/* Subtitle */}
                    <h2 className={techStyles.subtitle}>
                        SoC Architecture Built for Edge AI
                    </h2>

                    {/* First Paragraph */}
                    <p className={techStyles.paragraph}>
                        Traditional computing systems struggle because the full memory space
                        is too large to fit entirely on-chip and unpredictable in usage. To cope,
                        they rely on a layered memory hierarchy — with small, fast caches near the CPU
                        and larger storage like DRAM and SSD for bulk data. Cirkitex takes this concept further,
                        optimizing each layer for AI workloads at the edge, reducing latency, improving energy efficiency,
                        and ensuring critical data is always where it’s needed most.
                    </p>

                    {/* Section Title */}
                    <h3 className={techStyles.sectionTitle}>
                        Two key insights of our Compute-in-Memory approach :
                    </h3>

                    {/* List */}
                    <ol className={techStyles.list}>
                        <li className={techStyles.listItem}>AI inference workloads involve processing large amounts of data.</li>
                        <li className={techStyles.listItem}>Execution flow of a neural network is predictable, making data access patterns deterministic.</li>
                    </ol>

                    {/* Second Paragraph */}
                    <p className={`${techStyles.paragraph}`} style={{ marginTop: '1.2em', marginBottom: '2em' }}>
                        With this predictability, we can precisely manage where data is stored,
                        eliminating the need for complex cache hierarchies. Instead, we integrate
                        computation directly within each memory array, enabling data to be processed
                        right where it resides. This architecture delivers massive memory capacity
                        with performance and efficiency comparable to L1 cache or even register files.
                    </p>

                    {/* Image */}
                    <div className={techStyles.imageContainer}>
                        <img
                            className={techStyles.image}
                            src={logo}
                            alt="Technology architecture"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
